export type SvgEl = React.HTMLAttributes<HTMLOrSVGElement>;

export const IconCircleMinus: React.FC<SvgEl> = (props: SvgEl) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
      <path d="M40 0a40 40 0 1040 40A40 40 0 0040 0zm0 76.7A36.7 36.7 0 1176.7 40 36.7 36.7 0 0140 76.7zM22.7 41.8h34.6v-3.6H22.8z" />
    </svg>
  );
};
